import { useState } from 'react'
import { Container, Jumbotron } from 'react-bootstrap'
import ReportSearch from '../components/ReportSearch'
import Loader from '../components/Loader'

const Report = () => {
  const [loading, setLoading] = useState(false)

  return (
    <Container>
      <Jumbotron>
        {loading && (
          <Loader />
        )}
        <ReportSearch loading={loading} setLoading={setLoading} />
      </Jumbotron>
    </Container>
  )
}

export default Report
